import './styles.css';
import './lib/i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { createApiClient } from './lib/api/client';
import { createSession } from './lib/auth/session';
import { ServicesProvider } from './lib/auth/session-context';
import { PlatformProvider } from './lib/platform/context';
import { installEscapeToDismiss } from './lib/platform/escape';
import { resolvePlatform } from './lib/platform/resolve';
import { createAppRouter } from './routes/router';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});
// Resolved once, then injected. Nothing below this line knows which runtime
// it is in (TechSpec §8.2).
const platform = resolvePlatform();
installEscapeToDismiss(platform);
const session = createSession({
  tokens: platform.tokens,
  client: platform.kind,
  locks: typeof navigator !== 'undefined' ? navigator.locks : undefined,
});
const api = createApiClient(session);
const router = createAppRouter({ queryClient, session });

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <PlatformProvider value={platform}>
      <QueryClientProvider client={queryClient}>
        <ServicesProvider value={{ session, api }}>
          <App router={router} />
        </ServicesProvider>
      </QueryClientProvider>
    </PlatformProvider>
  </StrictMode>,
);
